import { useEffect } from 'react';
import i18n from '@app/app/i18n/config';
import { gtmInstance } from '@app/app/analytics/analytics';

/**
 * Хук для передачи текущего языка в аналитику (GTM)
 * Автоматически обновляет язык в dataLayer при смене языка
 * @param isBoxed - если true, хук не выполняет действий (для boxed режима)
 */
export const useAnalyticsLanguage = (isBoxed: boolean = false) => {
  useEffect(() => {
    if (isBoxed) return;

    // Получаем язык из i18n
    const currentLanguage = i18n.language;
    if (currentLanguage) {
      gtmInstance.setLanguage(currentLanguage);
    }

    // Слушаем изменения языка
    const handleLanguageChange = (lng: string) => {
      gtmInstance.setLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [isBoxed]);
};
